export default 'Prêts Bpifrance dédiés à la transition énergétique des TPE/PME (Prêt Vert ADEME et offres associées) : montage du dossier et articulation avec les primes CEE.';
